

import { Building2, Rocket, Briefcase, ArrowRight } from "lucide-react";

export const UseCases = () => {
  const cases = [
    { type: "Enterprises", title: "Drive Consistency & Scale", icon: <Building2 />, desc: "Standardize recruitment workflows across departments while maintaining quality at scale." },
    { type: "High-Volume", title: "Improve Speed", icon: <Rocket />, desc: "Reduce screening load significantly and slash time-to-hire for large-scale projects." },
    { type: "Staffing & RPO", title: "Increase Throughput", icon: <Briefcase />, desc: "Empower your recruitment teams with platform leverage to handle more roles effectively." }
  ];

  return (
    <section id="use-cases" className="py-32 bg-brand-secondary/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-24">
          <h2 className="text-4xl md:text-6xl font-display font-bold tracking-tight mb-6">Built for teams that need hiring to work</h2>
          <p className="text-xl text-brand-muted max-w-2xl mx-auto italic">QuantumHire adapts to the specific needs of modern recruitment teams.</p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {cases.map((c, i) => (
            <div key={i} className="glass p-12 rounded-[2.5rem] border border-gray-200 group hover:bg-white hover:shadow-2xl transition-all">
              <div className="w-16 h-16 rounded-full bg-black text-white flex items-center justify-center mb-8 border-4 border-gray-50">
                {c.icon}
              </div>
              <span className="text-brand-accent font-bold tracking-widest uppercase text-xs mb-3 block">{c.type}</span>
              <h3 className="text-2xl font-bold mb-4 tracking-tight">{c.title}</h3>
              <p className="text-gray-500 font-medium leading-relaxed mb-8">{c.desc}</p>
              <button className="text-sm font-bold flex items-center gap-2 group-hover:text-brand-accent transition-colors">
                Learn More <ArrowRight className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
